import { Outlet } from "react-router";

import { Tabs } from "@design-system/Tabs/Tabs";

import { routes } from "@pages/routes";
import { PortalSubNavigationTabs } from "@layouts/PortalPage/PortalSubNavigationTabs";

export const NotificationsLayout = () => {
  return (
    <>
      <PortalSubNavigationTabs>
        <Tabs style={{ borderBottom: "none", gap: "24px" }}>
          <Tabs.Tab
            name="Notifications"
            to={routes.portal.notifications.index.$buildPath({})}
            end={true}
          />
          <Tabs.Tab
            name="Rules"
            to={routes.portal.notifications.rules.$buildPath({})}
          />
        </Tabs>
      </PortalSubNavigationTabs>
      <Outlet />
    </>
  );
};
